export default __webpack_public_path__ + "static/media/certificate.89583f59.jpeg";